var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FieldBox',{staticClass:"outside-rth",attrs:{"title":_vm.$t('trade.before-after-market-open-deal')}},[_c('RadioBox',{attrs:{"disabled":_vm.disabled,"options":_vm.rthTypes},model:{value:(_vm.outsideRth),callback:function ($$v) {_vm.outsideRth=$$v},expression:"outsideRth"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }